<div *ngIf="successMessage!=null" class="alert alert-success alert-dismissible fade show ms-4 me-4 p-2" role="alert">
    <button type="button" class="btn-close" (click)="close()" data-bs-dismiss="alert" aria-label="close"></button>
    <!-- <mat-icon style="vertical-align: text-bottom;">thumb_up</mat-icon> &nbsp; -->
    <strong class="ps-2">{{successMessage}}</strong>
</div>
<div *ngIf="errorMessage!=null" class="alert alert-danger alert-dismissible ms-4 me-4 p-2">
    <button type="button" class="btn-close" (click)="close()" data-bs-dismiss="alert" aria-label="close"></button>
    <!-- <mat-icon style="vertical-align: text-bottom;">thumb_down</mat-icon> &nbsp; -->
    <strong class="ps-2">{{errorMessage}}</strong>
</div>